export const sidebar = {
  header: {
    menu: "القائمة",
  },
  items: {
    home: "الرئيسية",
    reservations: "الحجوزات",
    calendar: "التقويم",
    hourlyCalendar: "بالساعة",
    calls: "المكالمات",
    aiReception: "استقبال الذكاء الاصطناعي",
    availabilityRates: "الإتاحة والأسعار",
    checkins: "تسجيلات الوصول",
    channels: "قنوات الحجز",
    inbox: "صندوق الوارد",
    settings: "الإعدادات",
    experiences: "التجارب",
    scheduleCall: "احجز مكالمة",
    support: "الدعم",
    novedades: "الجديد",
    messages: "الرسائل",
    badgeNew: "جديد",
    invoicing: "الفوترة",
    customers: "العملاء",
    clientsDirectory: "العملاء",
    fiscalCustomers: "العملاء الضريبيون",
    invoices: "الفواتير",
    housekeeping: "التنظيف",
    analytics: "التحليلات",
  },
  alt: {
    logo: "الشعار",
  },
};
